<template>
  <div class='sub-page sub-page-leftmenu'>
    <div class='sub-content'> <!-- 여기까지 page header 이하 수정해서 사용-->
      <div class='user-grid'>
        <dx-data-grid ref='refUserGrid'
          :data-source='userInfoList'
          :show-borders = 'true' :showRowLines = 'false' :showColumnLines='true'
          :selection="{ mode: 'single' }" :hover-state-enabled = "true" :allowColumnResizing = 'true'
          column-resizing-mode = 'widget' :allow-column-reordering = "true"
          :row-alternation-enabled="true"
          :height='gridHeight'
          @selection-changed = "onSelectionChanged"
          @row-removed='onRowRemoved' @row-inserted='onRowInserted' @row-inserting='onRowInserting'
          @row-updated='onRowUpdated' @row-updating='onUpdating'
          @editor-preparing='onEditorPreparing' @content-ready='onContentReady'
          @init-new-row='onInitNewRow'
          @rowDblClick ='onRowDbClick'
        >
          <DxSearchPanel
            :visible="true"
            placeholder="검색..."
          />
          <DxExport
            :enabled="true"
            file-name="직원리스트"
          />
          <DxFilterRow
            :visible="true"
            apply-filter="auto"
          />
          <DxEditing
            :allow-deleting="(userInfo.permission & crudAllow) > 0"
            :allow-updating="(userInfo.permission & crudAllow) > 0"
            :allow-adding="(userInfo.permission & crudAllow) > 0"
            :use-icons="true"
            mode='popup'
          >
            <DxPopup
              :show-title="true"
              :width="600"
              :height="390"
              title="직원관리"
            >
              <dx-position
                my="center"
                at="center"
                of="window"
              />
            </DxPopup>
            <DxForm>
              <DxItem
              :col-count="2"
              :col-span="2"
              item-type="group"
              >
                <DxItem data-field="사번"/>
                <DxItem data-field="성명"/>
                <DxItem data-field="권한"/>
                <DxItem data-field="수수료율"/>
                <DxItem data-field="부서코드"/>
                <DxItem data-field="직책코드"/>
                <DxItem data-field="이메일"/>
                <DxItem data-field="연락처"/>
                <DxItem data-field="차량번호"/>
                <DxItem data-field="입사일"/>
                <DxItem data-field="퇴사일"/>
                <DxItem data-field="삭제유무"/>
              </DxItem>
            </DxForm>
          </DxEditing>
          <DxColumnFixing :enabled="true"/>
          <DxColumn
            :width="40"
            :fixed="true"
            :allow-sorting="false"
            data-field="포토url"
            cell-template="cellTemplate"
            caption='포토'
          />
          <DxColumn
            :allowEditing='isIdEdit'
            :fixed="true"
            caption="아이디"
            data-field="사번">
              <dx-required-rule message="사번을 입력하세요"/>
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            :fixed="true"
            sort-order='asc'
            caption="성명"
            data-field="성명"
            >
              <dx-required-rule message="항목을 입력하세요"/>
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="권한"
            data-field="권한"
            >
              <DxLookup
                :data-source="userGroup"
                display-expr="groupName"
                value-expr="permission"
              />
              <dx-required-rule message="항목을 선택하세요"/>
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="소속부서"
            data-field="부서코드"
            edit-cell-template="treeGridTemplate"
            >
              <DxLookup
                :data-source="divisionList"
                display-expr="부서명"
                value-expr="부서코드"
              />
          </DxColumn>

          <DxColumn
            :allowEditing='true'
            caption="직책"
            data-field="직책코드"
            :visible='true'
            >
            <DxLookup
              :data-source="positionLookup"
              display-expr="코드명"
              value-expr="코드명"
            />
          </DxColumn>
          <DxColumn
            :allowEditing="true"
            :visible="true"
            caption="수수료율"
            data-field="수수료율"
            format="#,##0.0%"
            dataType="number"
            :min-width="90"
            >
              <DxRequiredRule message="항목을 입력하세요"/>
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="이메일"
            data-field="이메일"
            :visible='true'
          >
            <dx-required-rule message="항목을 선택하세요"/>
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="연락처"
            data-field="연락처"
            :visible='true'
          >
            <dx-required-rule message="항목을 선택하세요"/>
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="주소"
            data-field="주소"
            :visible='true'
            >
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="차량번호"
            data-field="차량번호"
            :visible='true'
            >
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="입사일"
            data-field="입사일"
            dataType= 'date'
            format='yyyy-MM-dd'
            >
              <dx-required-rule message="항목을 입력하세요"/>
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="퇴사일"
            data-field="퇴사일"
            dataType= 'date'
            format='yyyy-MM-dd'
            >
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="사용정지"
            data-field="삭제유무"
            :visible='true'
            >
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            caption="등록일"
            data-field="createdTime"
            dataType= 'date'
            format='yyyy-MM-dd'
            >
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            :visible='true'
            caption="수정일"
            data-field="updatedTime"
            dataType= 'date'
            format='yyyy-MM-dd'
            >
          </DxColumn>
          <DxColumn v-if="(userInfo.permission & crudAllow) > 0"
            width="110"
            :buttons="editButtons"
            type="buttons"
          />
          <DxSummary>
            <DxTotalItem
              value-format='#,##0'
              show-in-column="사번"
              display-format="{0} (건)"
            />
          </DxSummary>
          <dx-paging :enabled="false"/>
          <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
          <dx-sorting mode="multiple"/>
          <template #treeGridTemplate="{ data: cellInfo }">
            <DivisionTreeGridComponent
              :value="cellInfo.value"
              :on-value-changed="cellInfo.setValue"
              :data-source="divisionList"
            />
          </template>
          <template #cellTemplate="{ data }">
            <div style="width:30px;height:30px;border-radius:50%;overflow:hidden">
              <img class='my-photo' :id="getId(data)" :src="getImageUrl(data.value)" style='width:100%'
                @click="toggleWithTemplate(data)"
              >
            </div>
          </template>
        </dx-data-grid>
        <DxTooltip v-for='(item, index)  in withTemplateVisible' :key="index"
          :visible.sync="item.visible"
          :close-on-outside-click="true"
          :target="item.targetId"
          position="right"
        >
          <div style="width:100px;height:100px;border-radius:50%;overflow:hidden">
            <img
              :src="getImageUrlFromUserInfo(index)" style='width:100%'
            >
          </div>
        </DxTooltip>
      </div>
      <loading :active.sync="isLoading" color='rgb(2, 110, 156)' loader='bars'></loading>
    </div> <!--sub-conten end-->
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import ConstDef from '../../share/ConstDef'
import DxDataGrid, { DxScrolling, DxFilterRow, DxExport, DxColumnFixing, DxTotalItem, DxForm,
  DxSummary, DxColumn, DxPaging, DxSorting, DxEditing, DxSearchPanel, DxLookup, DxPopup, DxPosition } from 'devextreme-vue/data-grid'
import { DxItem } from 'devextreme-vue/form'
import {
  DxRequiredRule
} from 'devextreme-vue/validator'
import DivisionTreeGridComponent from '../../share/component/devextream-template/DivisionTreeGridComponent'
import { DxTooltip } from 'devextreme-vue/tooltip'

export default {
  name: 'login',
  data: function () {
    return {
      crudAllow: ConstDef.SYSTEM_ADMIN,
      isLoading: false,
      selectedIndex: 0,
      editButtons: ['edit', 'delete',
        {
          hint: '암호초기화',
          icon: 'refresh',
          visible: 'true',
          onClick: this.onClickPasswdRefresh
        }],
      userInfoList: null,
      gridHeight: null,
      userInfo: null,
      isIdEdit: true,
      selectedRow: null,
      divisionList: null,
      positionLookup: null,
      popupQrcode: false,
      qrOptions: null,
      qrCodePopupTitle: null,
      userGroup: ConstDef.USER_PERMISSION,
      withTemplateVisible: [],
      companyInfoLookup: null,
      lineList: null,
      selectedLineCode: null
    }
  },
  components: {
    Loading,
    DxDataGrid,
    DxExport,
    DxFilterRow,
    DxColumnFixing,
    DxColumn,
    DxPaging,
    DxSorting,
    DxEditing,
    DxRequiredRule,
    DxSearchPanel,
    DxLookup,
    DxSummary,
    DxTotalItem,
    DxPopup,
    DxPosition,
    DxScrolling,
    DxItem,
    DxForm,
    DivisionTreeGridComponent,
    DxTooltip
  },
  created () {
    document.title = ConstDef.WEB_TAB_TITLE
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
      return
    }
    this.positionLookup = this.$store.getters.getBaseDataByType(ConstDef.직책)
    // console.log(this.$_appLib.uuidSequential())
    this.refreshDivision()
    this.refreshUser()
  },
  mounted () {
  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
    getId (data) {
      // // console.log(data)
      if (data.value !== null && data.value !== undefined) {
        let split = data.value.split('/')[3]
        return `PNG${this.$_appLib.replaceAll(split, '.', '')}`
      } else {
        return 'empty'
      }
    },
    getImageUrl (data) {
      if (data === null || data === undefined) {
        return '/image/user-circle.png'
      } else {
        return ConstDef.apiUrl + '/imgLoadAll?file=' + data
      }
    },
    getImageUrlFromUserInfo (index) {
      if (this.userInfoList[index].userImage === null || this.userInfoList[index].userImage === undefined) {
        return '/image/user-circle.png'
      } else {
        return ConstDef.apiUrl + '/imgLoadAll?file=' + this.userInfoList[index].포토url
      }
    },
    getTargetId (path) {
      if (path !== null) {
        let split = path.split('/')[3]
        // // console.log('#' + split.substring(0, 6))
        return '#PNG' + this.$_appLib.replaceAll(split, '.', '')
      } else {
        return ''
      }
    },
    toggleWithTemplate (data) {
      if (data.value !== null) {
        let index = this.$_.findIndex(this.userInfoList, { 포토url: data.data.포토url })
        // console.log(this.withTemplateVisible[index])
        this.withTemplateVisible[index].visible = !this.withTemplateVisible[index].visible
      }
    },
    onClickPasswdRefresh (e) {
      // // console.log(e)
      this.$snotify.confirm('사번으로 암호를 초기화 합니다. 초기화하시겠습니까?', '', {
        timeout: 10000,
        showProgressBar: true,
        closeOnClick: false,
        pauseOnHover: true,
        buttons: [
          { text: '초기화',
            action: (toast) => {
              this.$snotify.remove(toast.id)
              this.initPasswd(e.row.data)
            }
          },
          { text: '취소',
            action: (toast) => { this.$snotify.remove(toast.id) }
          }
        ]
      })
    },
    initPasswd (row) {
      // console.log(row)
      let param = {
        암호: row.사번,
        사번: row.사번
      }
      this.$_sp.runUpdateSqlProc('직원정보', ['사번'], null, [param])
        .then((data) => {
          this.$snotify.info('변경 되었습니다.')
        })
        .catch(error => {
          // // console.log(error)
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    onContentReady (e) {

    },
    onEditorPreparing (e) {
      if (e.dataField === '사번' && e.row !== undefined) {
        if (e.row.isNewRow === true) {
          this.isIdEdit = true
        } else {
          this.isIdEdit = false
        }
      }
    },
    onInitNewRow (row) {
      row.data.사용유무 = true
      row.data.삭제유무 = false
    },
    onRowDbClick (row) {
      this.$refs.refUserGrid.instance.editRow(row.rowIndex)
    },
    onRowInserted (row) {
      // // console.log(row)
      if (row.data.퇴사일 !== null && (typeof row.data.퇴사일) === 'object') {
        row.data.퇴사일 = this.$_appLib.formatDate(row.data.퇴사일.getTime())
      }
      if (row.data.입사일 !== null && (typeof row.data.입사일) === 'object') {
        row.data.입사일 = this.$_appLib.formatDate(row.data.입사일.getTime())
      }
      row.data.updatedId = row.data.createdId = this.userInfo.userId
      row.data.암호 = row.data.사번
      let array = []
      array.push(this.$_appLib.deleteUnderlineKey(row.data))
      // // console.log(array)
      this.$_sp.runInsertSqlProc('직원정보', ['라인명'], array)
        .then((data) => {
          this.$snotify.info('저장 되었습니다.')
          this.$refs.refUserGrid.instance.refresh()
        })
    },
    onRowInserting (row) {
      // console.log(row)
      if (this.$_.findIndex(this.userInfoList, { 사번: row.data.사번 }) >= 0) {
        row.cancel = true
        this.$snotify.error('사번이 중복되었습니다.')
      }
    },
    onRowRemoved (row) {
      this.$_sp.runDeleteSqlProc('직원정보', [{ 사번: row.data.사번 }])
        .then((data) => {
          this.$snotify.info('삭제되었습니다.')
        })
    },
    onUpdating (row) {
    },
    onRowUpdated (row) {
      // // console.log(row)
      row.data.updatedTime = this.$_appLib.getNow()
      row.data.updatedId = this.userInfo.userId
      if (row.data.퇴사일 !== null && (typeof row.data.퇴사일) === 'object') {
        row.data.퇴사일 = this.$_appLib.formatDate(row.data.퇴사일.getTime())
      }
      if (row.data.입사일 !== null && (typeof row.data.입사일) === 'object') {
        row.data.입사일 = this.$_appLib.formatDate(row.data.입사일.getTime())
      }

      let array = []
      array.push(this.$_appLib.deleteUnderlineKey(row.data))
      this.$_sp.runUpdateSqlProc('직원정보', ['사번'], null, array)
        .then((data) => {
          this.$snotify.info('저장 되었습니다.')
        })
    },
    onSelectionChanged (row) {
      if (row.selectedRowsData.length === 0) {
        return
      }
      this.selectedRow = row.selectedRowsData[0]
    },
    refreshDivision () {
      this.$_sp.runFindSqlProc('부서정보', null)
        .then((data) => {
          this.divisionList = this.$_sp.MakeModel(data)
          // console.log(this.divisionList)
        })
    },
    refreshUser () {
      this.isLoading = true

      this.$_sp.runFindSqlProc('직원정보', null)
        .then((data) => {
          this.userInfoList = this.$_sp.MakeModel(data)
          this.gridHeight = (screen.height - 250) * 0.95
          // console.log(this.userInfoList)
          this.isLoading = false
          this.withTemplateVisible = []
          for (let i = 0; i < this.userInfoList.length; i++) {
            this.withTemplateVisible.push({ visible: false, targetId: `${this.getTargetId(this.userInfoList[i].포토url)}` })
          }
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    }
  }
}
</script>

<style lang="scss">

</style>
